export const css = {
	root: '_30_9gJG_',
	' _key': 'certwise-theme/certwise/variants/pmp'
};

export default css;
